import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { LoginLimitProgressState, LoginLimitRemove, LoginLimitState, LoginLimitUpdate } from "./login-limit.model";

export const ACTION_PREFIX = "[Login Limit]";
export const PROGRESS_ACTION_PREFIX = "[Login Limit Progress]";

export const LOGIN_LIMIT_ACTION_TYPE = {
	get: `${ACTION_PREFIX} Get`,
	getSuccess: `${ACTION_PREFIX} Get Success`,
	getFail: `${ACTION_PREFIX} Get Fail`,

	update: `${ACTION_PREFIX} Update`,
	updateSuccess: `${ACTION_PREFIX} Update Success`,
	updateFail: `${ACTION_PREFIX} Update Fail`,

	remove: `${ACTION_PREFIX} Remove`,
	removeSuccess: `${ACTION_PREFIX} Remove Success`,
	removeFail: `${ACTION_PREFIX} Remove Fail`,

	reset: `${ACTION_PREFIX} Clear`,
};

export const LOGIN_LIMIT_PROGRESS_ACTION_TYPE = {
	get: `${PROGRESS_ACTION_PREFIX} Get`,
	getSuccess: `${PROGRESS_ACTION_PREFIX} Get Success`,
	getFail: `${PROGRESS_ACTION_PREFIX} Get Fail`,
};

@Injectable({
	providedIn: "root",
})
export class LoginLimitAction {
	get(): Action {
		return {
			type: LOGIN_LIMIT_ACTION_TYPE.get,
		};
	}

	getProgress(): Action {
		return {
			type: LOGIN_LIMIT_PROGRESS_ACTION_TYPE.get,
		};
	}

	getSuccess(payload: LoginLimitState): ActionWithPayload {
		return {
			type: LOGIN_LIMIT_ACTION_TYPE.getSuccess,
			payload,
		};
	}

	getProgressSuccess(payload: LoginLimitProgressState): ActionWithPayload {
		return {
			type: LOGIN_LIMIT_PROGRESS_ACTION_TYPE.getSuccess,
			payload,
		};
	}

	getFail(payload: AppError): ActionWithPayload {
		return {
			type: LOGIN_LIMIT_ACTION_TYPE.getFail,
			payload,
		};
	}

	getProgressFail(payload: AppError): ActionWithPayload {
		return {
			type: LOGIN_LIMIT_PROGRESS_ACTION_TYPE.getFail,
			payload,
		};
	}

	update(payload: LoginLimitUpdate): ActionWithPayload {
		return {
			type: LOGIN_LIMIT_ACTION_TYPE.update,
			payload,
		};
	}

	updateSuccess(): Action {
		return {
			type: LOGIN_LIMIT_ACTION_TYPE.updateSuccess,
		};
	}

	updateFail(payload: AppError): ActionWithPayload {
		return {
			type: LOGIN_LIMIT_ACTION_TYPE.updateFail,
			payload,
		};
	}

	remove(payload: LoginLimitRemove): ActionWithPayload {
		return {
			type: LOGIN_LIMIT_ACTION_TYPE.remove,
			payload,
		};
	}

	removeSuccess(): Action {
		return {
			type: LOGIN_LIMIT_ACTION_TYPE.removeSuccess,
		};
	}

	removeFail(payload: AppError): ActionWithPayload {
		return {
			type: LOGIN_LIMIT_ACTION_TYPE.removeFail,
			payload,
		};
	}

	reset() {
		return {
			type: LOGIN_LIMIT_ACTION_TYPE.reset,
		};
	}
}
